export type AttachmentRef = {
  url: string;
  name: string;
  size: number;
  mimeType: string;
};

export const BUCKET = "qorum-uploads";

export const MAX_FILES = 5;
export const MAX_BYTES = 15 * 1024 * 1024; // 15 MB

/** Formats effectivement acceptés par le greffe et extractibles côté serveur. */
export const ACCEPTED_EXT = [
  ".pdf",
  ".docx",
  ".txt",
  ".md",
  ".csv",
  ".png",
  ".jpg",
  ".jpeg",
  ".webp",
  ".gif",
] as const;

export const ACCEPTED_MIMES = [
  "application/pdf",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "text/plain",
  "text/markdown",
  "text/csv",
  "image/png",
  "image/jpeg",
  "image/webp",
  "image/gif",
] as const;

export const ACCEPT_ATTR = [...ACCEPTED_MIMES, ...ACCEPTED_EXT].join(",");

export const ACCEPTED_FORMATS_MESSAGE =
  "PDF, Word (.docx), images (JPEG, PNG, GIF, WebP), texte, Markdown, CSV — 15 Mo par fichier, 5 pièces par séance. Excel : convertissez en PDF ou en CSV.";

export function isAcceptedFile(file: File): boolean {
  if ((ACCEPTED_MIMES as readonly string[]).includes(file.type)) return true;
  const lower = file.name.toLowerCase();
  return ACCEPTED_EXT.some((ext) => lower.endsWith(ext));
}

export function appendAttachment(
  current: AttachmentRef[],
  attachment: AttachmentRef,
): AttachmentRef[] {
  return [...current, attachment];
}

export function formatBytes(n: number): string {
  if (n < 1024) return `${n} o`;
  if (n < 1024 * 1024) return `${Math.round(n / 1024)} Ko`;
  return `${(n / (1024 * 1024)).toFixed(1)} Mo`;
}

export function sanitizeFileName(name: string): string {
  return name.replace(/[^a-zA-Z0-9._-]+/g, "_").slice(-80);
}

export function buildStoragePath(
  userId: string,
  saisineTempId: string,
  fileName: string,
): string {
  return `saisines/${userId}/${saisineTempId}/${Date.now()}-${sanitizeFileName(
    fileName,
  )}`;
}
